import React, { Component } from 'react'
import { connect } from "react-redux";
import NoRow from '@/components/DataTable/CustomNoRow';

import InstrumentLightweightCharts from '@/components/@charting/InstrumentLightweightCharts'

import '../../../assets/styles/components/detail-center/chart.scss'


class Chart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isChart: true
    }
  }


    render() {
      const { isChart } = this.state
        return (
            <div className={this.props.chart_id !=="market-detail-chart"?'zoomChart':'chart'}  style={{width:'100%'}}>
                {isChart ? <InstrumentLightweightCharts chart_id={this.props.chart_id} ></InstrumentLightweightCharts>:
                  <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' ,minHeight:'300px', width :'100%'}} />
                }
            </div>
        )
    }
    componentDidUpdate(prevProps){
      this.displayChart(prevProps)
    }
    componentWillUnmount() {  
        this.setState = () => {
          return
        }
      }

    displayChart=(prevProps)=>{
      const { isChart } = this.state
      if(this.props.marketParams.marketID == undefined && this.props.marketParams !== prevProps.marketParams ){
        this.setState({
          isChart:false
        })
      }else if(isChart == false && this.props.marketParams !== prevProps.marketParams){
        this.setState({
          isChart:true
        })
      }
    }
    
    componentDidMount(){
      if(this.props.marketParams.marketID == undefined){
        this.setState({
          isChart:false
        })
      }
    }
}

Chart.defaultProps = {
  chart_id: 'market-detail-chart'
}
export default connect(
  (state)=>({
    marketParams: state.trade.marketParams,
  }),
  (dispatch) => ({
})
)(Chart)

